<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card flat max-width="500" class="pt-4">
      <report-image-upload
        :example="example"
        :instruction="instruction"
        :type="type"
        textAlt="report.additionalImage.textBtnAlt"
      />
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";

import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportImageSubmission from "@/mixins/ReportImageSubmissionMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportModule } from "@/store/modules/report.store";
import ReportImageUpload from "./ReportImageUpload.vue";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";

@Component({
  components: {
    ReportImageUpload,
    LayoutReportStep
  }
})
export default class ReportAdditionalImage extends ReportImageSubmission implements IReportStep {
  example = AssetEnum.scene;
  screen = ReportScreenEnum.additionalimage;

  get header(): IReportHeaderData {
    return {
      title: "report.additionalImage.title",
      description: "report.additionalImage.description",
      debug: this.files
    };
  }

  instruction: IReportInstructionData = {
    title: "",
    text: "",
    pictures: [AssetEnum.scene],
    example: AssetEnum.scene,
    display: false
  };

  get type() {
    return ReportImageType.scene;
  }

  get isDone() {
    return true;
  }

  /**
   * @inheritdoc
   */
  get files(): IImageUploaded[] {
    return ReportModule.damages;
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
